export default __webpack_public_path__ + "static/media/lgpd.00bce5c0.png";